import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { Icon } from '../Icon';
import styles from './InputError.module.css';
export const InputError = ({ message }) => {
    return (_jsxs("div", { className: styles.inputErrorContainer, children: [_jsx("div", { children: _jsx(Icon, { name: 'inputError', alt: 'Erro', style: { width: 13, height: 11 } }) }), _jsx("span", { className: styles.inputErrorText, children: message })] }));
};
